import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';
// viewBox="0 0 37 35"
export const ClockIllustration = ({ width = 37, marginLeft, marginRight, containerSize }: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg width="188" height="188" viewBox="0 0 188 188" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M93.9992 14.8008C50.2599 14.8008 14.8047 50.256 14.8047 93.9953C14.8047 137.735 50.2599 173.194 93.9992 173.194C137.738 173.194 173.194 137.735 173.194 93.9953C173.194 50.256 137.738 14.8008 93.9992 14.8008Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M93.9998 21.4492C53.9303 21.4492 21.4531 53.9311 21.4531 93.9959C21.4531 119.853 34.9732 142.546 55.3328 155.393L93.9998 94.5615V21.4492Z"
        fill="#FFBF00"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.0006 154.434C91.42 154.434 89.3256 152.339 89.3256 149.759V96.473L59.4711 65.9499C57.6665 64.108 57.6946 61.144 59.5412 59.3395C61.3832 57.5303 64.3471 57.563 66.1517 59.4143L97.3433 91.2978C98.1941 92.172 98.6756 93.3454 98.6756 94.5656V149.759C98.6756 152.339 96.5812 154.434 94.0006 154.434Z"
        fill="#1D1D1B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100.564 172.863C100.386 169.38 97.5295 166.598 93.9998 166.598C90.4702 166.598 87.6138 169.38 87.4408 172.863C48.9936 169.702 18.3724 139.123 15.1419 100.699C18.6856 100.582 21.528 97.6932 21.528 94.1215C21.528 90.5498 18.6809 87.656 15.1326 87.5485C18.2461 49.0125 48.8954 18.3164 87.4128 15.1328C87.4595 18.7372 90.3861 21.6497 93.9998 21.6497C97.6183 21.6497 100.545 18.7372 100.587 15.1328C139.109 18.3164 169.763 49.0218 172.872 87.5625C169.384 87.7355 166.603 90.5919 166.603 94.1215C166.603 97.6512 169.38 100.508 172.858 100.685C169.637 139.118 139.015 169.702 100.564 172.863ZM94 0.5C42.3646 0.5 0.5 42.36 0.5 94C0.5 145.635 42.3646 187.5 94 187.5C145.64 187.5 187.5 145.635 187.5 94C187.5 42.36 145.64 0.5 94 0.5Z"
        fill="#00396C"
      />
    </svg>
  </DefaultIconWrapper>
);
